import React from 'react';
import { useTranslation } from 'react-i18next';

import { maskValue } from '../helpers/mask';

/**
* Error page of checkout
*/
const ErrorPage = () => {
  const { t } = useTranslation('error');
  const { REACT_APP_CONTACT_EMAIL, REACT_APP_CONTACT_PHONE } = process.env;

  return (
    <section className='page'>
      <div className='page__container'>
        <h1 className='page__title'>
          {t(`title`)}
        </h1>
        <p className='page__text'>
          {t(`description`)}
        </p>
        <p className='page__text'>
          {t(`contact`)}
          <br />
          <br/>
          <a href={`mailto:${REACT_APP_CONTACT_EMAIL}`} target='_blank' rel='noopener noreferrer'>
            {REACT_APP_CONTACT_EMAIL}
          </a>
          <br />
          <a href={`https://wa.me/55${REACT_APP_CONTACT_PHONE}`} target='_blank' rel='noopener noreferrer'>
            {maskValue('(00) 00000-0000', REACT_APP_CONTACT_PHONE)}
          </a>
        </p>
      </div>
    </section>
  );
}
export default ErrorPage;